export default function Rate() {
  return {}
}
